module.exports = __webpack_public_path__ + "img/图片7.bc020812.png";